import moment from 'moment';
import templateUrl from './new-rs-payout-transfer.component.html';

export const NewRsPayoutTransferComponent = {
    controller: NewRsPayoutTransferController,
    controllerAs: "vm",
    bindings: {
        keyCollections: "<",
        afterSubmit: "&"
    },
    templateUrl
};

function NewRsPayoutTransferController(divisionService, utilityService, rsPayoutTransfersService, payrollService) {
    'ngInject';
    const vm = this;
    vm.afterSubmit;
    vm.editForm;
    vm.onSubmit = onSubmit;
    vm.$onInit = activate;
    vm.keyCollections;
    vm.programList;
    vm.storeList;
    vm.icdCorporatinList;
    vm.errorMsg;
    vm.onChangeProgram = onChangeProgram;
    vm.filteredStoreList;

    function activate() {

        window.onbeforeunload = onBeforeUnload;
        utilityService.showLoading();
        payrollService.retrieveAllPayrollCorporations()
            .then(function (corporations) {
                vm.icdCorporatinList = corporations.filter(function (corporation) {
                    // eslint-disable-next-line eqeqeq
                    return corporation.IcdCorporationID != vm.keyCollections.IcdCorporationID
                        && corporation.DivisionCountries.reduce(function (any, dc) {
                            // Only show RS companies in this list.
                            return dc.DivisionID === divisionService.divisionIDs.RoadShow;
                        }, false);
                });
            }).catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function onSubmit() {
        vm.errorMsg = null;
        utilityService.showLoading();
        vm.transfer.StartDate = moment(vm.keyCollections.Payweek.StartDate).format("YYYY-MM-DD");
        vm.transfer.EndDate = moment(vm.keyCollections.Payweek.EndDate).format("YYYY-MM-DD");
        vm.transfer.FromIcdCorporationID = vm.keyCollections.IcdCorporationID;
        const saveTransfer = rsPayoutTransfersService.createRSPayoutTransfer(vm.transfer);
        saveTransfer
            .then(function () {
                vm.editForm.$setPristine();
                location.reload();

            })
            .catch(function (ex) {
                vm.errorMsg = utilityService.getExceptionMessage(ex);
                utilityService.hideLoading();
            })
    }

    function onChangeProgram() {
        if (vm.transfer.ProgramID) {
            vm.filteredStoreList = vm.keyCollections.StoreList.filter(function (store) {
                // eslint-disable-next-line eqeqeq
                return store.ProgramID == vm.transfer.ProgramID
            });
        }
    }

    function onBeforeUnload() {
        if (vm.editForm.$dirty) {
            return "Any unsaved changes will be discarded.";
        }
    }
}
